export default function NosotrosContent() {

    return (
      
        <section className="w-75 mx-auto pt-5" style={{ textAlign: 'justify' }}>
<header className="mb-6">
<h1 className="text-2xl md:text-3xl font-bold mb-2">Nuestra historia</h1>
<p className="text-sm text-gray-600">Breve reseña sobre el nacimiento y propósito de COOPMULMAG</p>
</header>



<article className="space-y-4 text-justify text-gray-800 leading-relaxed">
<p>
En el año 2021 un grupo de emprendedores y comerciantes en el Distrito de Santa Marta, que desarrollaban
su actividad productiva y comercial en la informalidad con el apalancamiento financiero de los <em>gota a gota</em>,
por no contar con la formalidad y vida crediticia, y por la facilidad de acceso a los créditos; decidieron
organizarse para encontrar una ruta hacia la formalidad y buscar oportunidades para el fortalecimiento y
desarrollo de sus negocios. Buscaron alternativas en el marco de la asociatividad, para que aunando esfuerzos
se pudieran encontrar nuevas formas para el financiamiento, la inversión y el crecimiento rentable y sostenible
de sus negocios; y es allí donde decidieron constituir una cooperativa con el fin de generar procesos de ayuda
mutua para ayudarse entre todos.
</p>


<p>
Es así como nace La Cooperativa Multiactiva del Magdalena y del Caribe - <strong>COOPMULMAG</strong>, con la misión de apoyar a
las personas más vulnerables que requieren apoyo para sus emprendimientos, fortalecer sus negocios y recibir apoyo
empresarial y financiero. Se registró en Cámara de Comercio el día <strong>26 de enero de 2022</strong> con 20 asociados,
quienes de manera ordenada y con visión emprendedora organizaron la documentación y la capacitación para adelantar
los procesos de diseño de los estatutos, convocatoria de asamblea y registro y constitución.
</p>


<p>
En el <strong>2025</strong> se cuenta con más de <strong>365 asociados</strong> que, de acuerdo con el portafolio de servicios de la Cooperativa,
reciben atención para el apoyo, crecimiento y fortalecimiento de sus actividades familiares, personales, productivas
y comerciales, lo cual contribuye al mejoramiento de su calidad de vida y de las personas que dependen de ellos.
</p>
</article>

<hr className="my-6" />


<section id="mision" className="mb-6">
<h2 className="text-xl font-semibold mb-2">Misión</h2>
<p className="text-gray-800 leading-relaxed text-justify">
LA Cooperativa Multiactiva del Magdalena y del Caribe Y DEL CARIBE – <strong>COOPMULMAG</strong>, es una organización que busca el
mejoramiento de la calidad de vida de sus asociados, su núcleo familiar y de la comunidad en general, aportando a su
capacidad técnica, empresarial y económica para el emprendimiento, empresarismo y el comercio; mediante la promoción
de acciones sociales, productivas, comerciales, económicas, tecnológicas, culturales y ambientales, que propendan por
el desarrollo integral del ser humano y sus mecanismos de desarrollo personal y económico, entre los distintos grupos
poblacionales, con participación democrática, tolerancia y respeto a las diferencias.
</p>
</section>


<hr className="my-6" />
<section id="vision" className="mb-6">
<h2 className="text-xl font-semibold mb-2">Visión</h2>
<p className="text-gray-800 leading-relaxed text-justify">
LA Cooperativa Multiactiva del Magdalena y del Caribe Y DEL CARIBE – <strong>COOPMULMAG</strong>, será en el <strong>2030</strong> una organización
reconocida a nivel regional y nacional por su aporte al desarrollo económico, social y productivo de la región,
contribuyendo al mejoramiento de la calidad de vida de emprendedores y comerciantes de escasos recursos económicos,
como un modelo de innovación social para erradicar la pobreza en todas sus formas y para todos, promoviendo el
crecimiento económico sostenido, inclusivo y sostenible, el empleo pleno y productivo y el trabajo decente para todos;
en el marco de una cultura social y solidaria inclusiva y sostenible.
</p>
</section>


<hr className="my-6" />
<section id="principios" className="mb-6">

<div className="grid md:grid-cols-2 gap-6">
<div>
<h3 className="font-semibold">Principios</h3>
<ul className="list-disc list-inside mt-2 space-y-2 text-gray-800">
<li>
<strong>Adhesión voluntaria y abierta:</strong> COOPMULMAG es una organización voluntaria, abierta a todas las
personas capaces de utilizar sus servicios y dispuestas a aceptar las responsabilidades de la membresía, sin
discriminación de género, social, racial, política o religiosa.
</li>
<li>
<strong>Control democrático de los miembros:</strong> En COOPMULMAG nuestros asociados participan activamente en el
establecimiento de sus políticas y en la toma de decisiones. Los hombres y mujeres sirven como representantes
elegidos democráticamente con responsabilidad.
</li>
<li>
<strong>Participación económica:</strong> Los asociados de COOPMULMAG contribuyen equitativamente y controlan
democráticamente el capital de la cooperativa.
</li>
<li>
<strong>Autonomía e independencia:</strong> COOPMULMAG es una organización autónoma de autoayuda controlada por sus
miembros.
</li>
<li>
<strong>Educación, formación e información:</strong> Brindamos educación y capacitación a asociados, empleados y comunidad,
promoviendo el cooperativismo y la economía social y solidaria.
</li>
<li>
<strong>Cooperación entre cooperativas:</strong> Servimos a nuestros miembros de manera más efectiva y fortalecemos el
movimiento cooperativo trabajando juntos e integrados con las organizaciones del sector para el beneficio común.
</li>
<li>
<strong>Preocupación por la comunidad:</strong> Trabajamos para el desarrollo sostenible de nuestras comunidades a través
de políticas aprobadas por los asociados.
</li>
</ul>
</div>

<hr className="my-6" />

<div>
<h3 className="font-semibold">Valores</h3>
<ul className="list-disc list-inside mt-2 space-y-2 text-gray-800">
<li>
<strong>Ayuda mutua:</strong> En COOPMULMAG nos apoyamos, socorremos y cooperamos entre todos los miembros, para el beneficio
social, económico, productivo y humano de todos.
</li>
<li>
<strong>Responsabilidad:</strong> Respondemos por nuestros propios actos, garantizando el cumplimiento de los compromisos adquiridos.
</li>
<li>
<strong>Igualdad:</strong> Damos un trato a las personas sin que medie ningún tipo de reparo por la raza, sexo, clase social u otra
circunstancia; sin discriminación alguna.
</li>
<li>
<strong>Equidad:</strong> Damos un trato justo a los asociados, empleados y personas, dando a cada cual lo que le pertenece a partir del
reconocimiento de las condiciones y características específicas, con justicia y reconocimiento de la diversidad.
</li>
<li>
<strong>Solidaridad:</strong> Practicamos la solidaridad como principio de vida y fuente generadora de riqueza económica y capital social,
proporcionando apoyo espontáneo, generoso y voluntario en beneficio de otros.
</li>
</ul>
</div>
</div>
</section>



</section>
    )
}